import DepartingTomorrowIcon from 'components/ReusableComponents/Icons/DepartingTomorrow'

import ArrivingTodayIcon from './icons/ArringToday'
import ArrivingTomorrowIcon from './icons/ArrivingTomorrow'
import DepartingTodayIcon from './icons/DepartingToday'
import InHouseIcon from './icons/InHouseGuests'

export const inPropertyAudienceTypes = {
  InHouse: 'InHouse',
  ArrivingToday: 'ArrivingToday',
  ArrivingTomorrow: 'ArrivingTomorrow',
  DepartingToday: 'DepartingToday',
  DayBeforeCheckOut: 'DayBeforeCheckOut'
}

export const inPropertyAudiences = {
  InHouse: {
    name: 'In-house',
    description: 'Guests staying in-property',
    icon: InHouseIcon,
    accentColor: '#4299E1'
  },
  ArrivingToday: {
    name: 'Arriving today',
    description: 'Guest will check-in today',
    icon: ArrivingTodayIcon,
    accentColor: '#E94BA7'
  },
  ArrivingTomorrow: {
    name: 'Arriving tomorrow',
    description: 'Guests will check-in tomorrow',
    icon: ArrivingTomorrowIcon,
    accentColor: '#4299E1'
  },
  DepartingToday: {
    name: 'Departing today',
    description: 'Guests will check-out today',
    icon: DepartingTodayIcon,
    accentColor: '#48BB78'
  },
  DayBeforeCheckOut: {
    name: 'Departing tomorrow',
    description: 'Guests will check-out tomorrow',
    icon: DepartingTomorrowIcon,
    accentColor: '#F59E0B'
  }
}
